module.exports = __webpack_public_path__ + "static/media/shahzad.eff678be.jpeg";